import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Header } from '../../header';
import { useNavigate } from 'react-router-dom';

export const OrdersListPage = () => {
  const [orders, setOrders] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage] = useState(25);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const orderStatuses = {
    success: {
      color: 'bg-orange-500',
      text: 'Ожидает сборки и отправки',
      priority: 1
    },
    packed: {
      color: 'bg-blue-500',
      text: 'В доставке',
      priority: 2
    },
    cancelled: {
      color: 'bg-red-500',
      text: 'Отменён',
      priority: 3
    },
    finished: {
      color: 'bg-green-400',
      text: 'Выполнен',
      priority: 4
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await axios.get('https://api.alyonatestsite.store/api/orders', {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      setOrders(response.data);
    } catch (error) {
      console.error('Ошибка загрузки заказов:', error);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const filteredOrders = orders.filter(order => 
    order.id.toString().includes(searchQuery)
  );

  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;

  const sortedOrders = [...filteredOrders].sort((a, b) => {
    if (orderStatuses[a.status].priority !== orderStatuses[b.status].priority) {
      return orderStatuses[a.status].priority - orderStatuses[b.status].priority;
    }
    return b.id - a.id;
  });

  const currentOrders = sortedOrders.slice(indexOfFirstOrder, indexOfLastOrder);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const SkeletonCard = () => (
    <div className="relative w-full sm:w-80 rounded-lg text-left group">
      <div className="w-full h-64 bg-sky-200 relative overflow-hidden mb-3">
        <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
      </div>
      <div className="h-6 w-2/3 bg-sky-200 relative overflow-hidden mb-2">
        <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
      </div>
      <div className="h-3 w-2/4 bg-sky-200 relative overflow-hidden mt-4">
        <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
      </div>
    </div>
  );

  if (!orders) {
    return (
          <div>
            <Header page="merch" fixed={false} transparent={true} />
            <div className="p-4 md:p-8">
            <div className='flex flex-row space-x-4 items-center mb-6'>
          <button className='py-2 px-6 bg-blue-500 text-white w-fit rounded'
            onClick={() => navigate('/dashboard')}>
            Назад в ПУ
          </button> 
          <h1 className="text-3xl font-bold">Управление заказами</h1>
        </div>
        <input
          type="text"
          placeholder="Поиск по ID заказа"
          value={searchQuery}
          onChange={handleSearchChange}
          className="w-full md:w-1/3 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 py-32 gap-8">
                {Array.from({ length: 8 }, (_, index) => (
                  <SkeletonCard key={index} />
                ))}
              </div>
            </div>
          </div>
        );
  }

  return (
    <section className="min-h-screen bg-white">
      <Header fixed={false} />
      <div className='p-4 md:p-8'>
        <div className='flex flex-row space-x-4 items-center mb-6'>
          <button className='py-2 px-6 bg-blue-500 text-white w-fit rounded'
            onClick={() => navigate('/dashboard')}>
            Назад в ПУ
          </button> 
          <h1 className="text-3xl font-bold">Управление заказами</h1>
        </div>
        <input
          type="text"
          placeholder="Поиск по ID заказа"
          value={searchQuery}
          onChange={handleSearchChange}
          className="w-full md:w-1/3 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {currentOrders.map((order) => {
            const status = orderStatuses[order.status] || orderStatuses.success;
            return (
              <div 
                key={order._id} 
                onClick={() => navigate(`/dashboard/order/?id=${order.id}`)}
                className="border rounded p-4 shadow-md flex flex-row h-full space-x-2 cursor-pointer hover:shadow-lg transition-shadow"
              >
                <div className='h-full flex justify-center items-center px-3'>
                  <div className={`h-3 w-3 rounded-2xl ${status.color}`}></div>
                </div>
                <div className='flex flex-col'>
                  <div className='flex flex-row space-x-2'>
                    <h2 className="font-semibold text-lg font-lack">Заказ #{order.id}</h2>
                    <p className={`font-lack rounded px-2 text-white ${status.color}`}>
                      {status.text}
                    </p>
                  </div>
                  <p>{order.deliveryType === '136' ? 'До ПВЗ' : 'Курьером до двери'}, {order.cart.length} позиций, {order.amount} руб</p>
                </div>
              </div>
            );
          })}
        </div>
        <div className="mt-6 flex justify-center">
          {Array.from({ length: Math.ceil(filteredOrders.length / ordersPerPage) }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => paginate(i + 1)}
              className={`mx-1 px-4 py-2 border rounded ${currentPage === i + 1 ? 'bg-sky-400 text-white' : 'bg-white'}`}
            >
              {i + 1}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};